
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"Icon_Pause","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{attrs:{"id":"Masked_Area","fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"id":"Icon_Pause_Fill","clip-path":"url(#clip-path)","transform":"translate(2081 1782)"}},[_c('path',{staticClass:"cls-4",attrs:{"id":"Path_645","d":"M.722 0h2.337a.722.722 0 01.722.722v14.192a.722.722 0 01-.722.722H.722A.722.722 0 010 14.914V.722A.722.722 0 01.722 0z","transform":"translate(-2074.024 -1777.818)"}}),_c('path',{staticClass:"cls-4",attrs:{"id":"Path_644","d":"M.722 0h2.337a.722.722 0 01.722.722v14.192a.722.722 0 01-.722.722H.722A.722.722 0 010 14.914V.722A.722.722 0 01.722 0z","transform":"translate(-2067.757 -1777.818)"}})])])
          )
        }
      }
    